import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ClassTransformerHelper } from '../helpers/class.transformer.helper';
import { WorkflowData } from "../models/workflow/workflow.model";
import { WorkflowService } from "../services/workflow.service";
import { TemplateSettings, TemplateSettingsData } from "./modules/template/template.settings";
import { WorkflowControl, WorkflowEditOptions } from "./workflow.control";

@Component({
    selector: 'workflow-edit-dialog',
    templateUrl: 'workflow.edit.dialog.html',
    styleUrls: ['./workflow.edit.dialog.css']
})
export class WorkflowEditDialog implements OnInit {

    Data: WorkflowData = new WorkflowData();
    CloseOnCustomButton: boolean = true;
    CustomButtons = [{
        Caption: '@@Speichern'
    }];
    TemplatesLoaded = false;
    EditOptions = new WorkflowEditOptions();
    Workflow;
    @ViewChild('workflowControl') workflowControl: WorkflowControl;

    constructor(private dialogRef: MatDialogRef<WorkflowEditDialog>, private wfService: WorkflowService,
        private cdRef: ChangeDetectorRef, @Inject(MAT_DIALOG_DATA) public data: any) {
        if (data) {
            if (data.Data) {
                this.Data = ClassTransformerHelper.CopyObject(data.Data, WorkflowData);
            }
            this.EditOptions.Layout = data.Layout;
            this.Workflow = data.Workflow;
        }
    }

    ngOnInit(): void {
        this.wfService.GetAllWorkflowTemplates().subscribe(result => {
            if (result && result.length > 0) {                
                if (this.Data && this.Data.Modules) {
                    this.Data.Modules.forEach(function (mod) {
                        if ((mod.Module == TemplateSettingsData.ModuleID || mod.Module == TemplateSettings.ModuleID) && mod.Settings) {
                            result.some(function (r) {
                                if (r.Id == mod.Settings.TemplateID) {
                                    mod.Settings.TemplateName = r.Name;
                                    return true;
                                }
                                return false;
                            });
                        }
                    });
                }
                this.EditOptions.TemplateList = result;
            }
            this.TemplatesLoaded = true;
            this.cdRef.detectChanges();
        });
    }
    Save() {
        if (this.workflowControl != null) {
            this.workflowControl.CheckForSave().then((x) => {
                if (x) {
                    const json = JSON.stringify(this.Data);
                    const result = ClassTransformerHelper.Deserialize(WorkflowData, json);
                    this.dialogRef.close(result);
                }
            });
        } else {
            const json = JSON.stringify(this.Data);
            const result = ClassTransformerHelper.Deserialize(WorkflowData, json);
            this.dialogRef.close(result);
        }
    }
    Cancel() {
        this.dialogRef.close(null);
    }
}

